import axios from "axios";

let _accessToken = null;
let _refreshToken = sessionStorage.getItem("rag_refresh_token") || null;

export const api = axios.create({ baseURL: "" });

api.interceptors.request.use((config) => {
  if (_accessToken) config.headers["Authorization"] = `Bearer ${_accessToken}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry && _refreshToken) {
      original._retry = true;
      try {
        const res = await axios.post("/api/admin/auth/refresh", {
          refresh_token: _refreshToken,
        });
        _accessToken = res.data.access_token;
        _refreshToken = res.data.refresh_token;
        sessionStorage.setItem("rag_refresh_token", _refreshToken);
        original.headers["Authorization"] = `Bearer ${_accessToken}`;
        return api(original);
      } catch {
        clearTokens();
        window.location.reload();
      }
    }
    return Promise.reject(err);
  },
);

export function setTokens(access, refresh) {
  _accessToken = access;
  _refreshToken = refresh;
  if (refresh) sessionStorage.setItem("rag_refresh_token", refresh);
}

export function getRefreshToken() {
  return _refreshToken;
}

export function clearTokens() {
  _accessToken = null;
  _refreshToken = null;
  sessionStorage.removeItem("rag_refresh_token");
}

